import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 delete_order_item: { message: "idle" },
};

export const delete_order_item_Slice = createSlice({
 name: "delete_order_item",
 initialState,
 reducers: {
  success_delete_order_item: (state, action) => {
   state.delete_order_item = { status: app_consts.SUCCESS, data: action.payload };
   // Clear Exact Token
  },
  fail_delete_order_item: (state, action) => {
   state.delete_order_item = { status: app_consts.FAIL, message: action.payload };
  },
  reset_delete_order_item: (state) => {
   state.delete_order_item = { status: app_consts.IDLE };
  },
  loading_delete_order_item: (state) => {
   state.delete_order_item = { status: app_consts.LOADING };
  },
 }
});

export const { success_delete_order_item, fail_delete_order_item, reset_delete_order_item, loading_delete_order_item } = delete_order_item_Slice.actions;

export default delete_order_item_Slice.reducer;